import React from 'react';
import { ExtratoCD } from '@entidades';

interface IProps {
  contribuicoes: Array<ExtratoCD>;
}

export const ExtratoReais: React.FC<IProps> = ({
  contribuicoes
}) => {

  function ToMoney(Valor: number | undefined | null, FractionDigits = -1) {
    var options: any = {
      minimumFractionDigits: 2
    }
    if (FractionDigits > -1) {
      options = {
        minimumFractionDigits: FractionDigits,
        maximumFractionDigits: FractionDigits
      }
    }
    if (Valor === null || Valor === undefined)
      return 0;
    return (
      Valor.toLocaleString('pt-br', options)
    );
  }

  function renderContribuicoes() {

    const contribs = contribuicoes.map((contribuicao: ExtratoCD, index: number) => {
      return (
        <tr className={"text-right"} key={index}>
          <td className={"text-center"}>
            {contribuicao.MES_REF + "/" + contribuicao.ANO_REF}
          </td>
          <td >
            {ToMoney(contribuicao.SALDO_INICIAL_REAIS, 2)}
          </td>
          <td >
            {ToMoney(contribuicao.CONTRIB_PARTICIPANTE, 2)}
          </td>
          <td>
            {ToMoney(contribuicao.RISCO_PART, 2)}
          </td>
          <td>
            {ToMoney(contribuicao.ADM_PART, 2)}
          </td>
          <td>
            {ToMoney(contribuicao.CONTRIB_EMPRESA, 2)}
          </td>
          <td >
            {ToMoney(contribuicao.RISCO_PATROC, 2)}
          </td>
          <td>
            {ToMoney(contribuicao.ADM_PATROC, 2)}
          </td>
          <td>
            {ToMoney((contribuicao.VOLUNTARIA_PART), 2)}
          </td>
          <td >
            {ToMoney(contribuicao.PORTABILIDADE, 2)}
          </td>
          <td>
            {ToMoney(contribuicao.TOTAL_CONTRIB, 2)}
          </td>
          <td>
            {ToMoney(contribuicao.RENDIMENTO_MES, 2)}
          </td>
          <td>
            {ToMoney(contribuicao.SALDO_REAIS, 2)}
          </td>
          <td>
            {ToMoney(contribuicao.RENTABILIDADE, 4)}%
          </td>
        </tr>
      );
    });
    return (
      <div className={"table-responsive"}>
        <table className={"table table-striped table-bordered table-sm"}>
          <caption>
            (1) Básica: contribuição destinada a constituir a sua reserva;<br />
            (2) Risco: contribuição destinada ao custeio dos benefícios decorrente de evento não programado, como doença, invalidez ou morte do participante;<br />
            (3) Despesa Administrativa: contribuição destinada ao custeio das operações da Fundação;<br />
            (4) Total das Contribuições: Total das contribuições que compõem a sua reserva (contribuições básica, voluntária e recursos recebidos de portabilidade).
          </caption>
          <thead>
            <tr className={"text-center"}>
              <th className={"align-middle"}>
                {"Ref."}
              </th>
              <th className={"align-middle"}>
                {"Saldo Inicial"}
              </th>
              <th className={"align-middle"}>
                {"Básica Participante"}<sup>(1)</sup>
              </th>
              <th className={"align-middle"}>
                {"Risco Participante"}<sup>(2)</sup>
              </th>
              <th className={"align-middle"}>
                {"Adm. Participante"}<sup>(3)</sup>
              </th>
              <th className={"align-middle"}>
                {"Básica Patroc."}<sup>(1)</sup>
              </th>
              <th className={"align-middle"}>
                {"Risco Patroc."}<sup>(2)</sup>
              </th>
              <th className={"align-middle"}>
                {"Adm. Patroc."}<sup>(3)</sup>
              </th>
              <th className={"align-middle"}>
                {"Voluntária"}
              </th>
              <th className={"align-middle"}>
                {"Portabilidade"}
              </th>
              <th className={"align-middle"}>
                {"Contribuição Total"}<sup>(4)</sup>
              </th>
              <th className={"align-middle"}>
                {"Rentab. em R$"}
              </th>
              <th className={"align-middle"}>
                {"Saldo Final"}
              </th>
              <th className={"align-middle"}>
                {"Rentab. em %"}
              </th>
            </tr>
          </thead>

          <tbody>
            {contribs}
          </tbody>
        </table>
      </div>
    );
  }

  return renderContribuicoes();
}